// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vasD","buttons":"Footer_buttons__TfidL"};